export default __webpack_public_path__ + "static/Winner seal__NSW_Best Finance Broker-e207b9e6664a5456da26655ac4a4ecc9.png";